// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"7f3ef851","142":"62418d11","438":"3e275804","538":"9fd058fa","585":"612a8d98","648":"b32dd47d","725":"32b3e312","813":"a771dd48"}[chunkId] + ".chunk.js";
};